

































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { postDescription } from "../api";

@Component
export default class FeedbackForm extends Vue {
  @Prop({ required: true })
  token!: string;
  @Prop({ required: true })
  feedbackId!: number;

  description = "";

  @Watch("feedbackId")
  clearDescription(): void {
    this.description = "";
  }

  get disableButton(): boolean {
    return this.description === "";
  }

  async submit(): Promise<void> {
    if (!(await this.$validator.validate())) return;

    postDescription(this.token, this.feedbackId, this.description);
    this.$emit("submit");
  }
}
